
/*============================================================================
  Home page - social media
==============================================================================*/

var social = {
    twitter: function() {
        if (!window.twttr) {
            //Initialize twitter feed
            window.twttr = (function(d, s, id) {
                var t, js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s);
                js.id = id;
                js.src = "https://platform.twitter.com/widgets.js";
                fjs.parentNode.insertBefore(js, fjs);
                return window.twttr || (t = {
                    _e: [],
                    ready: function(f) {
                        t._e.push(f) }});
            }(document, "script", "twitter-wjs"));
        }

        if (window.twttr) {
            window.twttr.ready(function(twttr) {
                twttr.widgets.load(
                    document.getElementById("twitter-timeline")
                );
            });
        }
    },
    unload: function() {

    }
}

var instagram = {
    loadContent: function(s) {
        if (s.clientID) {
            var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + s.clientID;

            $.ajax({
                type: 'GET',
                url: url,
                dataType: 'jsonp',
                success: function(data) {

                    if (data.meta.code === 200 && data.data.length) {
                        var data = data.data;
                        var count = 0;
                        s.el.empty();

                        for (var i = 0; i < data.length; i++) {
                            var thisMedia = data[i],
                                item;

                            var url = thisMedia.images.low_resolution.url;

                            if (!thisMedia.images.low_resolution.url.indexOf("null") > -1) {
                                item = '<div class="il-photo__img instagram__bg" style="background-image:url(' + url + ')" data-filter="' + thisMedia.filter + '" /></div>';
                                item = '<a href="' + thisMedia.link + '" target="_blank" class="instagram__link">' + item + '</a>';
                            }

                            if (thisMedia.videos) {
                                item = '<div class="instagram__video instagram__bg" style="background-image:url(' + url + ')" data-filter="' + thisMedia.filter + '" /></div>';
                                item = '<a href="' + thisMedia.link + '" target="_blank" class="instagram__link instagram__video-link">' + item + '</a>';
                            }

                            if (item) {
                                item = '<div class="four columns instagram__item">' + item + '</div>';
                            }
                            if (item !== '') {
                                s.el.append(item);
                                count++;
                            }
                            if (count == s.limit) {
                                break;
                            }
                        } }},
                error: function() {}
            });
        }
    }
}

$('.social-feeds-wrap').each(function(index, value) {

    social.twitter();

    var $target = $(this).find(".js-instafeed");
    instagram.loadContent({
        el: $target,
        clientID: $target.data('client-id'),
        limit: $target.data('count')
    });
});

$(document).ready(function () {
    $(document).on('click', '[data-action="open-modal"]', function (e) {
        e.preventDefault();

        var modal = $(this).attr('aria-controls');

        $('#' + modal).attr('aria-hidden', 'false');
        $('html').addClass('no-scroll');
        $('.PageOverlay').addClass('is-visible');
    });

    $(document).on('click', '[data-action="close-modal"]', function (e) {
        e.preventDefault();

        var modal = $(this).closest('.Modal');

        modal.attr('aria-hidden', 'true');
        $('html').removeClass('no-scroll');
        $('.PageOverlay').removeClass('is-visible');
    });


    $('.account-sidebar li').click(function(){
      var tab_id = $(this).attr('data-id');
      $('.account-sidebar li').removeClass('current');
      $('.tab-content').removeClass('current');
      $(this).addClass('current');
      $("#"+ tab_id).addClass('current');
      if($(window).width() < 767) {
        $('.account-sidebar ul').toggleClass('show-full');
      }
    })

    // Quantity values
    $(document).on('click', 'button[data-quantity-increment]', function (e) {
      e.preventDefault();

      var input_quantity = $(this).parent().find('[data-quantity-input]');
      // Get its current value
      var currentVal = parseInt(input_quantity.val());
      // If is not undefined
      if (!isNaN(currentVal)) {
          // Increment
          input_quantity.val(currentVal + 1);
          input_quantity
      } else {
          input_quantity.val(1);
      }

      let data_price = parseInt($(this).closest('[data-product-id]').find('[data-money]').attr('data-money'));

      let subtotal = data_price * Math.max(parseInt(currentVal) + 1, 0);
      $(this).closest('[data-product-id]').find('[data-subtotal]').attr('data-subtotal', subtotal);
      $(this).closest('[data-product-id]').find('[data-subtotal]').html(Shopify.formatMoney(subtotal, $('[format-money]').attr('format-money')));
      let price_items = $('[data-subtotal]');
      var sumPrice = 0;
      price_items.map((i, item) => {
        let price = parseInt($(item).attr('data-subtotal'));
        sumPrice = sumPrice + price;
      })
      $('[data-stockit-subtotal]').html(Shopify.formatMoney(sumPrice, $('[format-money]').attr('format-money')));

    });

    $(document).on('click', 'button[data-quantity-decrement]', function (e) {
        e.preventDefault();

        var input_quantity = $(this).parent().find('[data-quantity-input]');
        // Get its current value
        var currentVal = parseInt(input_quantity.val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 1) {
            // Decrement one
            input_quantity.val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            input_quantity.val(0);
        }
        let data_price = parseInt($(this).closest('[data-product-id]').find('[data-money]').attr('data-money'));

        let subtotal = data_price * Math.max(parseInt(currentVal) - 1, 0);
        $(this).closest('[data-product-id]').find('[data-subtotal]').attr('data-subtotal', subtotal);
        $(this).closest('[data-product-id]').find('[data-subtotal]').html(Shopify.formatMoney(subtotal, $('[format-money]').attr('format-money')));

        let price_items = $('[data-subtotal]');
        var sumPrice = 0;
        price_items.map((i, item) => {
          let price = parseInt($(item).attr('data-subtotal'));
          sumPrice = sumPrice + price;
        })
        $('[data-stockit-subtotal]').html(Shopify.formatMoney(sumPrice, $('[format-money]').attr('format-money')));
    });

    $(document).on('click', 'button[data-stockit-button-checkout]', function (e) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      var addToCartButton = $(this);

      var ProductItems = $('.table-stockit-shop').find('[data-product-id]');

      // First, we switch the status of the button
      addToCartButton.attr('disabled', 'disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      var formData = {
        'items': []
      }

      ProductItems.each(function (i) {
        var quantity = parseInt($(this).find('[name="quantity"]').val());
        formData.items.push({
          quantity: quantity,
          id: parseInt($(this).attr('data-product-id'))
        });
      });

      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (result) {
            location.href = '/checkout';
        },
        error: function (error) {
          console.log(error);
        }
      });

  });

  $(document).on('click', '.js-infinite-scroll', function(e){
    e.preventDefault();
    let url = $(this).attr('href');
    let $container;
    const listData = $('[data-blog-list]');
    $.get(url).done(function (data) {
      $container = $(data).find('[data-blog-list]');
      listData.append($container.children());
      $('[data-blog-paginate]').replaceWith($(data).find('[data-blog-paginate]'));
    });
  });

  $(document).on('click', '.js-open-video', function(){
    $(this).closest('.blog-article__item').find('.blog-modal').fadeIn(300);
    $(this).closest('.blog-article__item').find('.blog--video.active video')[0].play();
    // nextPlayVideo();
  });

  $(document).on('click', '.js-close-video', function(){
    $('.blog-modal').fadeOut(300);
    $(this).closest('.blog-article__item').find('.blog--video.active video')[0].pause();
  })
});
